export enum NavTarget {
    ORDERS = "orders",
    BANKING = "banking",
    UNBLOCK = "unblock"
}